import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/purchase-invoice-status/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const purchaseInvoicesStatus = {
  getAll: apiPathFunc(pathBase),
} as const;
